import React from "react"
import CustomContainer from "../../components/CustomContainer"
import CustomHeader from "../../components/TextComponents/CustomHeader"
import CustomGenderHeader from "../../components/TextComponents/CustomGenderHeader"
import CustomItemsSwiper from "../../components/Swiper/CustomItemsSwiper"
import CustomCategoryHeader from "../../components/TextComponents/CustomCategoryHeader"
import CustomFractionalSwiper from "../../components/Swiper/CustomFractionalSwiper"
import CustomProductIntro from "../../components/ProductComponents/CustomProductIntro"

const CategorySection = ({ data, desktopDisplay = 3 }) => {
  return (
    <>
      {/* Moderate Trail Section */}
      <CustomContainer extra_class="mb-[4rem]">
        <CustomHeader text={data?.header} variant="h2" />
        <CustomHeader text={data?.subtitle} variant="h4" />
      </CustomContainer>

      <CustomContainer extra_class="mb-[4rem]">
        <CustomContainer extra_class="mb-[4rem]">
          <CustomFractionalSwiper
            desktopDisplay={desktopDisplay}
            slides={data?.product_intro.map((intro, index) => (
              <CustomProductIntro
                key={index}
                src={intro.src}
                title={intro?.title}
                description={intro.description}
              />
            ))}
          />
        </CustomContainer>

        {/* Category */}
        <CustomContainer extra_class="mb-4">
          {data?.product_category.map((category, index) => (
            <div key={index}>
              <CustomCategoryHeader text={category} />
              <br className="hidden" />
            </div>
          ))}
        </CustomContainer>

        {data?.products.map((category, index) => {
          return (
            <CustomContainer key={index} extra_class="mb-[4rem]">
              <CustomGenderHeader text={category?.header} />
              <CustomItemsSwiper products={category?.items} />
            </CustomContainer>
          )
        })}
      </CustomContainer>
    </>
  )
}

export default CategorySection
